import Appointment from "../interface/appointment";

/**
 * Maps an appointment to its human-readable German status text, matching what
 * the overview table shows. Booked ("G") appointments whose date is in the past
 * count as "beendet".
 */
const getAppointmentStatusText = (appointment: Appointment): string => {
  if (
    appointment.status === "G" &&
    new Date(appointment.date).toISOString().split("T")[0] <
      new Date().toISOString().split("T")[0]
  )
    return "beendet";

  switch (appointment.status) {
    case "G":
      return "gebucht";
    case "F":
      return "frei";
    case "K":
      return "storniert";
    case "V":
      return "versäumt";
    default:
      return "Unbekannt";
  }
};

export default getAppointmentStatusText;
